<template>
  <Modal :value="value" @hide="hide()" :title="title">
    <template slot="body" class="content">
      <div v-if="!groupItem" class="margin-bottom-1">
        <BInput
          v-model="groupName"
          type="text"
          validation="required"
          placeholder="New group name"
          name="name"
          focus="true"
        ></BInput>
      </div>

      <p>Select all the computers that should be in this group.</p>

      <div v-if="groupItem" class="">
        <SearchBar
          v-model="tempFilter"
          :id="searchId"
          :selectOnSubmit="true"
          :loading="searching"
          :focus="groupItem"
          @submit="search($event)"
        ></SearchBar>
      </div>

      <p v-if="filtered.length === 0"><i>No computers.</i></p>

      <ComputersSelect
        v-show="filtered.length !== 0"
        :computers="filtered"
        :selectedUIDs="selectedUIDs"
        :domain="domain"
        @change="selectedUIDs = $event"
        :disabled="isLoading"
      ></ComputersSelect>

      <div v-if="!isValid" class="margin-bottom-20">
        <tips-notification
          path="groups"
          xKey="dismissedTips"
          property="groupAdd"
        >
          <p>
            Consider the packages in a group as policies. An installed group
            package will tell the computers to install that package according to
            the schedule (if any).
          </p>
        </tips-notification>
      </div>

      <transition
        name="custom-classes-transition"
        enter-active-class="pulse-fast-once"
        appear
      >
        <div v-show="isValid && !this.groupItem" class="margin-bottom-20">
          <GroupCopy :min="4" @change="packages = $event">
            <div class="notification is-primary is-light">
              <p>Would you like to add packages from other groups?</p>
              <p>
                Packages will be copied with the same settings, schedules and
                parameters. All packages will be applied immediately when
                saving.
              </p>
              <p>Groups with duplicate packages will be hidden.</p>
            </div>
          </GroupCopy>
        </div>
      </transition>
    </template>
    <template slot="footer" class="content">
      <div v-if="!isLoading">
        <div
          @click="save()"
          :disabled="!isValid"
          class="button is-success"
          :class="{ 'is-loading': isLoading }"
        >
          Save
        </div>
        <div class="button" @click="hide()">Cancel</div>
      </div>
      <div v-show="isLoading" class="spinner-wrapper center">
        <span class="spinner is-centered"></span>
      </div>
    </template>
  </Modal>
</template>

<script>
import { focus, getId } from "@/utils/document";
import computerHelper from "@/utils/computer";

export default {
  props: {
    value: Boolean,
    title: String,
    groupItem: Object,
    domain: Object,
  },
  components: {
    Modal: () => import("@/components/main/Modal.vue"),
    BInput: () => import("@/components/singles/BInput/component.vue"),
    CheckboxText: () => import("@/components/singles/CheckboxText.vue"),
    IconText: () => import("@/components/singles/IconText.vue"),
    SearchBar: () => import("@/components/main/SearchBar.vue"),
    ComputersSelect: () => import("@/components/main/group/MultiSelect.vue"),
    GroupCopy: () => import("@/components/main/group/GroupCopy.vue"),
    TipsNotification: () => import("@/components/main/TipsNotification.vue"),
  },
  data() {
    return {
      groupName: "",
      tempFilter: "",
      searching: false,
      filter: "",
      searchId: getId(),
      computers: [],
      selectedUIDs: [],
      isLoading: false,
      packages: [],
    };
  },
  computed: {
    isValid() {
      return !(
        (!this.groupItem && this.groupName === "") ||
        this.selectedUIDs.length === 0
      );

      // return (
      //   !this.groupItem &&
      //   this.groupName !== "" &&
      //   this.selectedUIDs.length !== 0
      // );
    },
    name() {
      return (computer) => {
        return computerHelper.getName(computer);
      };
    },
    filtered() {
      if (this.filter) {
        return this.$store.state.computer.computers.filter(
          (x) =>
            x.name.toLowerCase().includes(this.filter) ||
            (x.friendlyName &&
              x.friendlyName.toLowerCase().includes(this.filter))
        );
      } else return this.$store.state.computer.computers;
    },
  },
  async created() {
    if (this.groupItem) {
      this.selectedUIDs = this.groupItem.computers.map((x) => x.uid);
    }
  },
  methods: {
    save() {
      if (!this.isLoading && this.isValid) {
        this.isLoading = true;
        let original = [];

        if (this.groupItem)
          original = this.groupItem.computers.map((x) => x.uid);

        const removed = original.filter((x) => !this.selectedUIDs.includes(x));
        const added = this.selectedUIDs.filter((x) => !original.includes(x));
        const all = this.selectedUIDs;

        this.$emit("save", {
          name: this.groupName,
          added,
          removed,
          all,
          packages: this.packages,
        });
      }
    },
    async search(searchStr) {
      this.searching = true;
      this.filter = searchStr.toLowerCase();
      this.searching = false;
      focus(this.searchId);
    },
    hide() {
      if (!this.isLoading) {
        this.$emit("hide", false);
        this.$emit("input", false);
      }
    },
  },
};
</script>
